import { Controller } from "stimulus";
import { calculatePasswordEntropy } from "./password-strength.js";

export default class PasswordStrength extends Controller<HTMLDivElement> {
	declare inputTarget: HTMLInputElement;
	declare meterTarget: HTMLInputElement;
	static targets = ["input", "meter"];
	connect() {
		this.inputTarget.addEventListener("change", () => {
			this.calculate();
		});
		this.inputTarget.addEventListener("keydown", (e) => {
			setTimeout(() => this.calculate(this.inputTarget.value + e.key), 0);
		});
	}

	calculate(password: string = this.inputTarget.value) {
		const quality = Math.max(1, calculatePasswordEntropy(password));
		this.meterTarget.style.setProperty(
			"width",
			Math.min((quality / 200) * 100, 100) + "%"
		);
		const color =
			quality < 30 || isNaN(quality)
				? "#FF4136" /* red */
				: quality < 80
				? "#FF851B" /* orange */
				: "#2ECC40"; /* green */
		this.meterTarget.style.setProperty("background-color", color);
	}
}
